import { isEmpty } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import modalMixin from '@phoenix/mixins/modalMixin';
import StoreFinderInModal from '@maison/components/store/StoreFinderInModal';
import StoreResultsInModal from '@maison/components/store/StoreResultsInModal';

export default {
  components: {
    StoreFinderInModal,
    StoreResultsInModal,
  },

  mixins: [modalMixin],

  props: {
    boutiqueOnly: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState('storeSelector', ['stores', 'query', 'isLoading']),

    hasStore() {
      return !isEmpty(this.stores);
    },
  },

  methods: {
    ...mapActions('storeSelector', ['searchStore', 'setStorePageId', 'reset']),

    search(query) {
      this.searchStore({
        query,
        boutiqueOnly: this.boutiqueOnly,
      });
    },
  },
};
